export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=fbd3739e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/agents/index.vue?vue&type=template&id=fbd3739e&scoped=true
// module id = 9t3V
// module chunks = 0